/** Constants for element types */
export const ELEMENT_TYPE = {
    UNITS_OF_MEASURE: 'UnitsOfMeasure',
    TEXT: 'Text'
} as const